export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            required: false
        }
    },
    methods: {
        close() {
            this.$emit('close')
        }
    },
    template: `
        <transition>
            <div v-if="show" class="c-media-modal">
                <div class="c-media-modal_bg" @click="close"></div>
                <div class="c-media-modal_outer">
                    <div class="c-media-modal_inner">
                        <slot></slot>
                    </div>

                    <span class="c-media-modal_title" v-if="title">{{title}}</span>

                    <button class="c-media-modal_close" @click="close">
                        <span class="u-screen-reader-text">Fermer</span>
                        <svg role="img"><use href="/assets/images/sprite.svg#close"></use></svg>
                    </button>
                </div>
            </div>
        </transition>
    `
}
